module.exports = __webpack_public_path__ + "9b40b0b432848e3e0b81a17e3947274b.png";